import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/AppReducer';
import { ScreenType } from '../../../../common/view-model';
import { FC, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import ToastComponent from '../ToastComponent';
import { ToastActions } from '../../../../redux/toast/ToastActions';
import 'react-toastify/dist/ReactToastify.css';
import { useAppDispatch } from '../../../../redux/store';
const images = import.meta.glob('../../../../assets/images/toast/*.png', { eager: true });

const getImagePath = (imageName: string) => {
	const path = `../../../../assets/images/toast/${imageName}.png`;
	return (images[path] as { default: string }).default || '';
};
interface ToastContainerComponentProps {}
const ToastContainerComponent: FC<ToastContainerComponentProps> = () => {
	const dispatch = useAppDispatch();
	const toastCleanUp = () => dispatch(ToastActions.clearToast());
	const toastState = useSelector(({ appState: state }: RootState) => state.toastState);
	const isMobile = useSelector(
		({ appState: state }: RootState) => state.deviceScreen === ScreenType.MOBILE
	);
	useEffect(() => {
		if (toastState) {
			toast(
				<ToastComponent
					title={toastState.title}
					text={toastState.message}
					isMobile={isMobile!}
					afterAction={toastState.afterAction}
					afterActionText={toastState.afterActionText}
					undoAction={toastState.undoAction}
					undoActionText={toastState.undoActionText}
				/>,
				{
					position: toastState.position,
					icon: <img src={getImagePath(toastState.type)} />,
					className: `${toastState.message !== '' ? 'with-message' : 'no-message'} toast-${
						toastState.type
					}`,
					closeOnClick: toastState.closeOnClick,
					autoClose: toastState.autoClose,
					onClose: toastCleanUp
				}
			);
		}
	}, [toastState]);
	return toastState ? (
		<ToastContainer
			style={{ width: !isMobile ? '450px' : '282px' }}
			autoClose={toastState?.autoClose || 5000}
			toastClassName={`toast-${toastState?.type}`}
		/>
	) : null;
};

export default ToastContainerComponent;
